import React, { useEffect, useCallback, useState} from 'react';
import {
    setQuickAddSearchText,
} from 'actions/index.js';
import SourceEditor from './SourceEditor.js';
import SampleSearch from './SampleSearch.js';
import SourceResults from './SourceResults.js';
import DayResults from './DayResults.js';
import SoundGrid from './SoundGrid.js';
import {getBlockMonths} from 'utils/getBlockMonths.js';
import Months from 'components/explore/work/Months.js';
import {connect} from 'react-redux';
import '../../NewSelector.scss';
import '../../Selector.scss';
import {GRID, LIST, DAY, TAG} from './constants.js';
import SourceToSearch from "components/selector2/SourceToSearch.js";
import PackToSearch from "components/selector2/PackToSearch.js";

const Selector = ({sequencerEngine, guildId, quickAddSearchText, setSearchText}) => { 
    let [months, setMonths] = useState({});
    let [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    let [day, setDay] = useState(undefined);
    let [displayOption, setDisplayOption] = useState(GRID);
    let [groupBy, setGroupBy] = useState(TAG);
    let [source, setSource] = useState(undefined);
    let [sourceToSearch, setSourceToSearch] = useState(undefined);
    let [packToSearch, setPackToSearch] = useState(undefined);
    console.log("SELECTOR QUICK ADD SEARCH=", quickAddSearchText);
    let [searchTerm, setSearchTerm] = useState(quickAddSearchText);
    let [filterFavorites, setFilterFavorites] = useState(false);
    let [sourceToEdit, setSourceToEdit] = useState(undefined);

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [setDay, setSource, setSourceToEdit, setSourceToSearch, setDisplayOption, displayOption]);

    const onKeyDown = useCallback((e) => {
        if (e.key==='ArrowLeft') {
            goBack();
        } else if (e.key === "Tab") {
            /*
            setDisplayOption(
                displayOption === GRID ?
                    LIST : GRID);
                    */
        }
    }, [setDay, setSource, setSourceToEdit, setSourceToSearch, setDisplayOption, displayOption]);
   
    useEffect(() => {
        setSourceToSearch(undefined);
        setPackToSearch(undefined);
    }, [searchTerm, setGroupBy, setSourceToSearch, setPackToSearch]);

    useEffect(() => {
        if (searchTerm === "" && !filterFavorites) {
            setDisplayOption(GRID);
        }
    }, [searchTerm, filterFavorites, setDisplayOption]);


    const onClickSource = useCallback((e, source) => {
        if (e.metaKey) {
            setDay(undefined);
            setSourceToEdit(source);
            return;
        }
        setDay(undefined);
        setSource(source);
    }, [setDay, setSource]);

    const onClickDay = useCallback((day, tag) => {
        setSource(undefined);
        setDay(day);
    }, [setSearchTerm, setSource, setDay, groupBy]);

    let results = undefined;
    let backButton = '';
    let hasBack = false;

    const goBack = useCallback(() => {
        setDay(undefined);
        setSource(undefined);
        setSourceToEdit(undefined);
        setSourceToSearch(undefined); 
        setPackToSearch(undefined); 
    }, [setDay, setSource, setSourceToEdit, setSourceToSearch, setPackToSearch]);

    if (day || source || sourceToEdit || sourceToSearch || packToSearch) {
        hasBack = true;
        backButton = 
            (<div
               onClick={goBack}
               className="selector-back-button"/>);
        if (sourceToEdit) {
            results = (<SourceEditor sequencerEngine={sequencerEngine} source={sourceToEdit}/>);
        } else if (sourceToSearch) {
            results = <SourceToSearch
                        setPackToSearch={setPackToSearch}
                        sourceToSearch={sourceToSearch}
                        sequencerEngine={sequencerEngine}/>;
        } else if (packToSearch) {
            results = <PackToSearch
                        setPackToSearch={setPackToSearch}
                        packToSearch={packToSearch} sequencerEngine={sequencerEngine}/>;
        } else {
            results = 
                source ? <SourceResults
                           setPackToSearch={setPackToSearch}
                           alone={true} sequencerEngine={sequencerEngine} source={source}/> :
            <DayResults setPackToSearch={setPackToSearch} sequencerEngine={sequencerEngine} day={day}/>;
        }
    }

    useEffect(() => {
        if (quickAddSearchText !== '') {
            setSearchTerm(quickAddSearchText);
            setSource(undefined);
            setDay(undefined);
            // setDisplayOption(LIST);
        }
    }, [quickAddSearchText, setSearchTerm, setDisplayOption, setSource, setDay]);

    useEffect(() => {
        setDay(undefined);
        setSource(undefined);
    }, [displayOption]);

    const onChange = useCallback((s) => {
        setDay(undefined);
        setSource(undefined);
        setSourceToSearch(undefined);
        setSearchTerm(s);
        setSearchText(s);
    }, [setSearchTerm, setDay, setSource, setSourceToSearch]);

    useEffect(() => {
        onChange(quickAddSearchText);
    }, [guildId, setSearchTerm, setDay, setSource, setSourceToSearch]);

    return (
        <div className={hasBack ? "new-selector has-back" : "new-selector"}>
           <div className="selector-inner">
             <SoundGrid
               groupBy={groupBy}
               setPackToSearch={setPackToSearch}
               packToSearch={packToSearch}
               displayOption={displayOption} 
               searchTerm={searchTerm}
               filterFavorites={filterFavorites}
               setSourceToSearch={setSourceToSearch}
               onClickSource={onClickSource}
               onClickDay={onClickDay}
               guildId={guildId}
               resultsElement={results}
               sequencerEngine={sequencerEngine}>
               <SampleSearch
                 sourceToSearch={sourceToSearch}
                 setDisplayOption={setDisplayOption}
                 displayOption={displayOption}
                 groupBy={groupBy}
                 setGroupBy={setGroupBy}
                 onChange={onChange}
                 setFilterFavorites={setFilterFavorites}
                 filterFavorites={filterFavorites}>
                 <div className="search-and-back">{backButton}</div>
               </SampleSearch>
             </SoundGrid>
           </div>
        </div>);
    /* <Months onClickMonth={onClickMonth} currentMonth={currentMonth} months={months}/> */
};

const mapStateToProps = (state, props) => {
  return {
      quickAddSearchText: state.selector.quickAddSearchText,
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Selector);
